/**
 * EmptyState — переиспользуемая заглушка для пустых/будущих секций
 * (дизайн-система КОММА).
 *
 * Использование:
 *   <EmptyState text="Нет данных за период" />
 *   <EmptyState text="Скоро" icon={<Icon name="Clock" />} description="…" />
 *
 * См. styles/global.css (.empty, .empty__ic).
 */

import type { ReactNode } from 'react';
import { Icon } from '@/shared/ui';

export interface EmptyStateProps {
  text: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  variant?: 'default' | 'compact';
}

export function EmptyState({
  text,
  description,
  icon,
  action,
  variant = 'default',
}: EmptyStateProps) {
  const compact = variant === 'compact';
  return (
    <div
      className="empty"
      style={{
        padding: compact ? '32px 20px' : '56px 20px',
        border: '1px dashed var(--border-strong)',
        background: 'var(--surface)',
        borderRadius: 'var(--r-lg)',
      }}
    >
      <span className="empty__ic">{icon ?? <Icon name="Clock" />}</span>
      <div className="col center" style={{ gap: 4 }}>
        <div style={{ fontWeight: 800, fontSize: compact ? 15 : 16.5 }}>{text}</div>
        {description && (
          <div className="muted" style={{ fontSize: 13.5, maxWidth: 380 }}>
            {description}
          </div>
        )}
      </div>
      {action}
    </div>
  );
}
